import { useQuery } from '@tanstack/react-query';

import { fetchInitialQuoteAccessorials } from '../data-provider/initial-quote-accessorials';

export const useInitialQuoteAccessorials = () => {
  return useQuery({
    queryFn: () => fetchInitialQuoteAccessorials(),
    queryKey: ['initial-quote-accessorials'],
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
  });
};
